import React from "react";
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';

const NumberFormatDollars = React.forwardRef(function NumberFormatDollars(props, ref) {
  const { inputRef, onChange, ...numberFormatProps } = props;

  return (
    <NumericFormat
      {...numberFormatProps}
      getInputRef={ref || inputRef}
      allowNegative={false}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
      prefix="$"
    />
  );
});

NumberFormatDollars.propTypes = {
  inputRef: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default NumberFormatDollars;
